import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)


export function setupParallaxImages(scroller, locoScroll) {

  if(!scroller) { return false }
  if(!window.innerWidth > 1200) { return false }

  //add css styling only when this function has been called
  //this transforms image for parallax animation
  $('.js-paralax-image').addClass('is-active')

  let percent = 25

  gsap.utils.toArray('.js-paralax-image').forEach(image => {
    gsap.set(image, { yPercent: percent })
    gsap.fromTo(image, { yPercent: percent }, {
      yPercent: 0,
      ease: "none",
      scrollTrigger: {
        trigger: image,
        start: "top bottom+=5%", // the default values
        end: "bottom top+=20%",
        scrub: true,
        scroller: scroller,
        onEnter: (instance) => {
          $(instance.trigger).addClass('is-animating')
        },
        //markers: true
      },
    })
  })


}

